
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["exportToFile"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "03c86cc0427f56789ec6.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			